import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import type { AgreementInfo, HasAgreementsResponse, UserInfo } from '../generated-types';
import { getUserAgreement, getUserInfo, hasMultipleAgreements } from '../services/profileService';

const useProfile = (enabled = true): QueryResult<UserInfo> =>
    useQuery({ queryKey: ['profile'], queryFn: getUserInfo, refetchOnWindowFocus: true, enabled });

export const useAgreement = (): QueryResult<AgreementInfo | undefined> =>
    useQuery({
        queryKey: ['agreement'],
        queryFn: getUserAgreement,
    });

export const useMultipleAgreements = (): QueryResult<HasAgreementsResponse> =>
    useQuery({
        queryKey: ['multiple-agreements'],
        queryFn: hasMultipleAgreements,
        staleTime: Infinity,
    });

export default useProfile;
